import type { Product } from '@customink/project-service-react-components';

export type HighColorMode = 'altColor' | 'altStyle' | 'noAlt';

export const getHighColorMode = (product: Product): HighColorMode => {
  // When an alternative (DTG-enabled) color exists:
  if (product.colors.some((c) => c.dtg_enabled)) {
    return 'altColor';
  }
  // When an alternative style exists:
  if (!!product.singles_alternative_id) {
    return 'altStyle';
  }
  // When no alternatives exist:
  return 'noAlt';
};
